import { Trans } from '@lingui/react';
import { Alert } from '@startuptools/ui/Alert';
import { Button } from '@startuptools/ui/Button';
import { Typography } from '@startuptools/ui/Typography';
import WarningIcon from '@mui/icons-material/Warning';
import { Box } from '@startuptools/ui/joy/Box';

export const FREE_SHAREHOLDERS_LIMIT = 5;
export const FREE_SHAREHOLDERS_LIMIT_STR = <Trans id="five" />;
export const STARTER_SHAREHOLDERS_LIMIT = 15;
export const STARTER_SHAREHOLDERS_LIMIT_STR = <Trans id="fifteen" />;
export const GROW_SHAREHOLDERS_LIMIT = 25;
export const GROW_SHAREHOLDERS_LIMIT_STR = <Trans id="twentyfive" />;

export const FREE_COMPANIES_LIMIT = 5;

interface UpgradeBannerProps {
  navigateToBilling: () => void;
  feature: 'share_register' | 'company_count';
  companyLimit?: number | null | undefined;
  customShareRegisterLimit?: number | null | undefined;
}

export const UpgradeBanner = ({
  navigateToBilling,
  feature,
  companyLimit,
  customShareRegisterLimit,
}: UpgradeBannerProps) => {
  const messageContent = {
    share_register: {
      title: <Trans id="Upgrade to your plan" />,
      description: (
        <Trans
          id="You have reached the max amount of shareholders for your plan. Upgrade to unlock more modules directly."
          values={{
            customShareRegisterLimit,
          }}
        />
      ),
    },
    company_count: {
      title: <Trans id="Upgrade your plan to add more companies" />,
      description: (
        <Trans
          id="You can add up to {freeLimit} free companies. To add more companies, please upgrade to a suitable plan."
          values={{
            freeLimit: companyLimit ?? FREE_COMPANIES_LIMIT,
          }}
        />
      ),
    },
  };

  return (
    <Alert
      sx={{ alignItems: 'flex-start', backgroundColor: 'primary.solidBg' }}
      startDecorator={<WarningIcon sx={{ color: 'white' }} />}
      variant="soft"
      endDecorator={
        <Button variant="soft" onClick={navigateToBilling} sx={{ color: 'white' }}>
          <Trans id="Upgrade" />
        </Button>
      }
    >
      <div>
        <Box sx={{ color: 'white' }}>{messageContent[feature].title}</Box>

        <Typography level="body-sm" sx={{ color: 'white' }}>
          {messageContent[feature].description}
        </Typography>
      </div>
    </Alert>
  );
};
